// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { Div, H2 } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import { Icon } from 'opencare-crown';
import { DIMENSIONS } from 'providers/WindowDimensionsProvider';

import ProfileImageCircles from '../../../common/components/ProfileImageCircles/ProfileImageCircles';

import { VerticallyCentered, ViewButton } from './styled-components';

// Other

// Component
const ProviderInfoHeader = ({
  expanded,
  layout,
  name,
  onExpandToggle,
  photo,
}) => (
  <VerticallyCentered>
    <ProfileImageCircles
      height="50px"
      images={[photo]}
      width="50px"
      presentationOnly
    />
    <H2
      color={colors.charcoal}
      display="inline"
      fontWeight="300"
      margin="10px"
      verticalAlign="middle"
    >
      {name}
    </H2>
    <Div margin="0 0 0 auto">
      <ViewButton
        border={`1px solid ${colors.darkBlue}`}
        color={colors.darkBlue}
        onClick={onExpandToggle}
        padding="10px 0"
        type="secondary"
      >
        {expanded
          ? (
            <>
              <Icon type="up" />
              {layout !== DIMENSIONS.MOBILE && <span>View less</span>}
            </>
          )

          : (
            <>
              <Icon type="down" />
              {layout !== DIMENSIONS.MOBILE && <span>View more</span>}
            </>
          )}
      </ViewButton>
    </Div>
  </VerticallyCentered>
);
ProviderInfoHeader.propTypes = {
  expanded: PropTypes.bool,
  layout: PropTypes.string,
  name: PropTypes.string,
  onExpandToggle: PropTypes.func,
  photo: PropTypes.object,
};

export default ProviderInfoHeader;
